import React, { Component , Fragment, useState,useEffect,useRef } from "react";
import { Link,useNavigate } from 'react-router-dom';
import { AuthContext } from "../context/authContext";
import { useContext } from "react";
import profileService from "../services/profile.service";
import {uploadImages } from "../files";
import Profilephoto from '../components/Profilephoto';
import alertService from '../services/sweetAlert';
import axios from "axios";

function Account() {

const { currentUser } = useContext(AuthContext);
const [name, setName] = useState("");
    const [profileImage, setProfileImage] = useState("");
    const [location, setLocation] = useState("")
    const [bio, setBio] = useState("")
    const [file, setFile ]= useState("")
    const [pdetails,setPdetails] = useState([]);
    const cdn ='https://files.geetsuhane.com/users/';
    const inputRefName = useRef(null);
    const inputRefBio = useRef(null);
    const inputRefAddress = useRef(null);
    const inputRefLocation = useRef(null);
    const inputRefBmonth = useRef(null);
    const inputRefBday = useRef(null);


    const updateuser = async(name,filePath) => {
        if(currentUser?.name)
        currentUser.name =name;       
        if(filePath.length>0) {
            currentUser.picture = filePath;  
        }
    }
    
    let formData = new FormData();
    const profileDetails = async () => {
        // console.log(currentUser);
        // var profie = await profileService.getProfile({
        //   uid: currentUser?currentUser.id:'',
        var profie = await profileService.getResult({
            qry: `CALL sp_getProfile('${currentUser?.id}') `
        });
      
        //console.log(profie);
        // localStorage.setItem("SID",profie?.[0][0]?.sid);
        if(profie!=null  ) {
            if(profie?.length>0) {
            

            let pdetail = profie?.[0][0];
           // console.log(pdetail);
            // setLocation(pdetail.location?pdetail.location:'');
            // setName(pdetail.name?pdetail.name:'');
            // setBio(pdetail.bio?pdetail.bio:'');
            localStorage.setItem("pimage",pdetail?.picture?''+cdn+pdetail?.picture:"");
            setProfileImage(pdetail?.picture?''+cdn+pdetail?.picture:'');
            setPdetails(pdetail);
            updateuser (pdetail?.name?pdetail?.name:'',pdetail?.picture?pdetail?.picture:'')
            }
            //const pdetails=profie[0];
            
        }
    }
        
    var updateProfile = async () => {
       if(inputRefName.current.value==="") {
        //return alert("name field is empty!");
        alertService.info(
            'Profile Update',
            'name field is empty!'
          )   
          return;
       }
       var filePath = ""
       if(file) {
        //console.log('filePath:'+file)
        setProfileImage(URL.createObjectURL(file));
         filePath = currentUser.id+'/profile/'+file.name;
       }
        
       
       
        saveProfile(filePath);
        if(file) {
            //const uploadTask = await uploadImages(file,filePath);
            formData.append('file', file);
            formData.append('filePath', filePath);
            //const baseUrl = "http://localhost:3005/profile/uploafile";
            const baseUrl = process.env.REACT_APP_API_END_POINT+"/profile/uploadfile";
             
            axios.post(baseUrl, formData, { headers: {'Content-Type': 'multipart/form-data'}})
                .then((res) => {
                    console.log(res);
                    if (res.status === 201)                     
                        return;
    
                })
                .catch((error) => {
                  alertService.info(
                    'Update profile',
                    'OOps, some issues while uploading image, please try after some time!'
                  );                     
    
                })
        }
        updateuser (inputRefName,filePath.length>0?filePath:'')
  
      
      };

      const saveProfile = async (filePath) => {
      
         

        await profileService.saveProfile({
          uid: currentUser?.id,
          pname: inputRefName.current.value,  
          location: inputRefLocation.current.value,
          bio: inputRefBio.current.value,
          address: inputRefAddress.current.value,
          dp: file?filePath:'',
          dobmon : inputRefBmonth.current.value===''?null:inputRefBmonth.current.value,
          dobday: inputRefBday.current.value===''?null:inputRefBday.current.value
        })
        // if(inputRefBday.current.value>0 && inputRefBmonth.current.value>0)
        //     //console.log(inputRefBday)
        //   var dob = await profileService.getResult({
        //     qry: `CALL sp_updateProfile('${currentUser?.id}',${inputRefBmonth.current.value},${inputRefBday.current.value}) `
        // });
        alertService.success(
            'Profile Update',
            'Successfully Updated!'
          )   
        //setFile('');
        // setFileContent('');
        // setFileType('');
        //setName('');
      };

      const handleFileChange = (e) => {
        const img = e.target.files[0];
        //console.log(img);
        setProfileImage(URL.createObjectURL(img));
      
        setFile(img);
       
      };


    const navigate = useNavigate()
    //console.log(currentUser);
  
    if(currentUser==null)
    {
      navigate('/login')
    } 

    useEffect(() => {
        //console.log(currentUser)
        async function fetchProfile() {
          await profileDetails();
        }
        fetchProfile();
      }, []);
// class Account extends Component {
    
        return (
            <Fragment> 
              
                <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
            
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/userpage" className="d-inline-block mt-2"><i className="ti-arrow-left font-sm text-white"></i></Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">Account Details</h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0 ">
                                   

                                    <form action="#">
                                        <div className="row">
                                            <div className="col-lg-6 mb-3">
                                                <div className="form-group">
                                                    <label className="mont-font fw-600 font-xsss mb-2">Display Name (with GS tag 🌍GS🎷)</label>
                                                    <input type="text" defaultValue={pdetails?.name} className="form-control" placeholder="e.g. user🇺🇸🌍GS🎷" ref={inputRefName} />
                                                </div>        
                                            </div>

                                        <div className="col-lg-6 mb-3">
                                                <div className="form-group">
                                                    <label className="mont-font fw-600 font-xsss mb-2">Location</label>
                                                    <input type="text" defaultValue={pdetails?.location} className="form-control" placeholder="e.g. Delhi, India (Optional)" ref={inputRefLocation} />
                                                </div>        
                                            </div>
                                        </div>

                                        <div className="row">
                                        <div className="col-lg-2 mb-3">
                                        <div className="form-group">
                                                    <label className="mont-font fw-600 font-xsss mb-2">Birth Day</label>
                                                    <input type="number" min="1" max="31"   defaultValue={pdetails?.bday} className="form-control" placeholder="e.g. 1" ref={inputRefBday} />
                                                </div> 
                                            </div>
                                        <div className="col-lg-2 mb-3">
                                        <div className="form-group">
                                                    <label className="mont-font fw-600 font-xsss mb-2">Birth Month</label>
                                                    <input type="number" min="1" max="12"   defaultValue={pdetails?.bmonth} className="form-control" placeholder="e.g. 1" ref={inputRefBmonth} />
                                                </div> 
                                            </div>
                                           
                                        </div>

                                        <div className="row">
                                        <div className="col-lg-12 mb-3">
                                                <label className="mont-font fw-600 font-xsss mb-2 text-dark">Bio</label>
                                                <textarea  className="form-control mb-0 p-3 h100 bg-greylight lh-16" rows="5" defaultValue={pdetails?.bio} ref={inputRefBio} placeholder="Write your bio (optional)..." ></textarea>
                                            </div>
                                            <div className="col-lg-12 mb-3">
                                                <label className="mont-font fw-600 font-xsss mb-2 text-dark">Address (visible to you only)</label>
                                                <textarea  className="form-control mb-0 p-3 h100 bg-greylight lh-16" rows="5" defaultValue={pdetails?.address} ref={inputRefAddress} placeholder="Write your name, address, phone (optional)..." ></textarea>
                                            </div>
                                           
                                        </div>


                                        <div className="row">
                                         

                                            <div className="col-lg-12 mb-3">
                                                <div className="card mt-3 border-0">
                                                    <div className="card-body d-flex justify-content-between align-items-end p-0">
                                                    <div className="row justify-content-center" style={{paddingBottom:'30px'}}>
                                      
                                    </div>
                              
                                                        <div className="form-group mb-0 w-100">
                                                            
                                                            <input type="file" name="file" id="file"  onChange={handleFileChange}  className="input-file" />
                                                            
                                                            <label htmlFor="file" className="rounded-3 text-center bg-white btn-tertiary js-labelFile p-4 w-100 border-dashed">
                                                          
                                                                                                     
                                            <figure className="avatar ms-auto me-auto mb-0 mt-2 w100"><img src={profileImage == '' ? "assets/images/user.png" : profileImage} alt="avater" className="shadow-sm rounded-3 w-100" /></figure>                                                                                                              
                                                <span className="js-fileName">Drag and drop or click to replace  DP</span>
                                                          
                                                            </label>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            

                                            <div className="row justify-content-center">
                                                <a  onClick={updateProfile} className="bg-current text-center text-white font-xsss fw-600 p-3 w175 rounded-3 d-inline-block">Save</a>
                                            </div>
                                        </div>

                                    </form>
                                    </div>
                                </div>
                                  <Profilephoto/>      
                            </div>
                        </div>
                       
                    </div>     
                  
                </div>
               
            </Fragment>
        );
        }


export default Account;